module.exports = __webpack_public_path__ + "assets/img/img231.3c82e4c0.png";